export const PRIMARY_BTN_VARIANT = {
  color: "primary",
} as const;
export const SECONDARY_BTN_VARIANT = {
  color: "secondary",
} as const;
export const TERTIARY_BTN_VARIANT = {
  variant: "text",
} as const;
